export const ColorScheme = {
    // primary: "cornflowerblue",
    primary: "white",
    samwilkins: "red"
}